module.exports = __webpack_public_path__ + "img/SUPAVirus.ca643f6c.png";